module.exports = __webpack_public_path__ + "media/images/icons/message-center-130308faa8ee99209691f0216baef1ea.svg";